import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[numbersOnlyDirective]',
})
export class NumbersOnlyDirective {
  pattern = /[0-9]/;
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) inputHandler() {
    const inputVal = this.el.nativeElement.value;
    const arrayword = inputVal.split('');
    let newVal = '';

    arrayword.forEach((item) => {
      if (this.pattern.test(item)) {
        newVal += item;
      }
    });
    const arrText = newVal.split('');

    this.control.control.setValue(
      newVal.replace(/\b0+[1-9]\d*/g, arrText[arrText.length - 1])
    );
  }

  // disable Paste function for text box
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }
}
